@let item = navItem();
@let hasChildren = !!item.children?.length;

<input
  type="hidden"
  [routerLink]="item.route"
  routerLinkActive
  [routerLinkActiveOptions]="{ exact: hasChildren }"
  #navRoute="routerLinkActive"
  [id]="item.id + '_is-route-active'" />
@let isActive = navRoute.isActive;

<input
  type="hidden"
  #navExpanded
  [id]="item.id + '_expanded'"
  [value]="isParentActive() ? 'expanded' : 'collapsed'" />

@let isSectionExpanded = navExpanded.value === 'expanded';

<div
  class="nav-item"
  [class.is-active]="hasChildren ? isParentActive() : isActive"
  [class.has-children]="hasChildren"
  [class.with-side-nav-expanded]="isSideNavExpanded()"
  (click)="handleClick(item)">
  @if (item.id === 'horizon_sso') {
    <img
      class="c24-logo-img"
      style="height: 1rem; width: 1rem; transform: scale(1.5)"
      [attr.src]="'/assets/images/crisis24-logo-reverse.svg'" />
  } @else {
    <topo-icon [props]="item.iconProps" />
  }

  @if (isSideNavExpanded()) {
    <span
      animate.enter="enter-animation"
      animate.leave="leave-animation">
      {{ item.label | translate }}
    </span>

    @if (hasChildren) {
      <div class="child-routes-toggle">
        <i
          class="icon icon-caret_medium_down"
          [class.rotated]="isSectionExpanded"></i>
      </div>
    }
  } @else {
    <topo-nav-item-hover-menu
      [navItem]="item"
      class="menu-trigger">
      <div
        ngProjectAs="trigger"
        class="menu-trigger"></div>
    </topo-nav-item-hover-menu>
  }
</div>

@if (hasChildren) {
  <div
    class="child-routes"
    [class.hidden]="!isSectionExpanded || !isSideNavExpanded()"
    [class.expanded]="isSectionExpanded">
    @for (childItem of item.children; track childItem.id) {
      <div
        class="nav-item child-route"
        [routerLink]="childItem.route"
        routerLinkActive="is-active"
        (isActiveChange)="handleIsActiveChange(childItem.id, $event)">
        <span>{{ childItem.label | translate }}</span>
      </div>
    }
  </div>
}
